import type { PayloadAction, Reducer } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'
import type { PortalReducerState, RequiredChain, ThemeName } from './types/PortalReducerState'

const urlParams = new URLSearchParams(window.location.search)
const urlTheme = urlParams.get('theme')
const defaultTheme: ThemeName =
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- user passed theme
  (urlTheme as ThemeName) || 'rhino'

const getInitialPortalReducerState = (): PortalReducerState => ({
  // Meta data
  selectedTheme: defaultTheme,
  requiredChain: null,

  // Global config
  config: {},
})

const portalSlice = createSlice({
  name: 'portal',
  initialState: getInitialPortalReducerState(),
  reducers: {
    setRequiredChain: (
      state,
      {
        payload: { requiredChain },
      }: PayloadAction<{
        requiredChain: RequiredChain | null
      }>,
    ) => {
      return {
        ...state,
        requiredChain,
      }
    },
    setConfig: (state, { payload: { config } }: PayloadAction<{ config: PortalReducerState['config'] }>) => {
      return {
        ...state,
        config,
      }
    },
  },
})

export const portalReducer: Reducer<PortalReducerState> = portalSlice.reducer
export const { setConfig, setRequiredChain } = portalSlice.actions
